import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { redirect, useNavigate } from 'react-router-dom';
import { Loader } from 'lucide-react';

const SplashScreen = ({ controlled = false }) => {
    const navigate = useNavigate();

    useEffect(() => {
        const timeout = setTimeout(() => {
            return !controlled && navigate("/login");
        }, 2000)
        return () => {
            clearTimeout(timeout);
        }
    }, [controlled])
    return (
        <div className="w-screem h-screen flex items-center flex-col justify-center">
            <motion.img
                src="/logo_sm.png"
                alt="Logo"
                initial={{ scale: 0, y: -50 }}
                animate={{
                    scale: 1,
                    y: 0
                }}
                transition={{
                    type: "spring",
                    stiffness: 400,
                    damping: 10,
                    mass: 1,
                    bounce: 0.5
                }}
                className="h-32 w-38"
            />
            <motion.h1
                className="text-primary/70 font-bold mt-2 text-sm uppercase flex items-center gap-1"
                initial={{ opacity: 0, y: -20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{
                    duration: 0.3,
                    delay: 0.6,
                    ease: "easeOut"
                }}
            >
                Loading... <Loader className='animate-spin' />
            </motion.h1>
        </div>
    );
};

export default SplashScreen;